import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PageSectionNav from "./PageSectionNav";
import ArtistComboBox from "../ArtistComboBox";
import { artistsWithExhibitionsApiRequest } from "../../../api";

function NavBar({ onFilterChange, visibleSections }) {
  const initCheckboxState = (id, label, changeHandler) => {
    return {
      id: `exhibitions-landing-checkbox-${id}`,
      label: label,
      parameter: id,
      checked: false,
      onChange: changeHandler,
    };
  };

  const [artists, setArtists] = useState([]);
  const [soloCheckbox, setSoloCheckbox] = useState(
    initCheckboxState("solo", "Solo Exhibitions", onSoloCheckboxChange)
  );
  const [groupCheckbox, setGroupCheckbox] = useState(
    initCheckboxState("group", "Group Exhibitions", onGroupCheckboxChange)
  );
  const [fairsCheckbox, setFairsCheckbox] = useState(
    initCheckboxState("art_fairs", "Art Fairs", onFairsCheckboxChange)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [artistQuery, setArtistQuery] = useState({ all: 1 });

  function onSoloCheckboxChange(query) {
    onFilterChange(query);
    setSoloCheckbox((prevState) => {
      return { ...prevState, checked: !prevState.checked };
    });
  }

  function onGroupCheckboxChange(query) {
    onFilterChange(query);
    setGroupCheckbox((prevState) => {
      return { ...prevState, checked: !prevState.checked };
    });
  }

  function onFairsCheckboxChange(query) {
    onFilterChange(query);
    setFairsCheckbox((prevState) => {
      return { ...prevState, checked: !prevState.checked };
    });
  }

  function onArtistChange(selection) {
    resetCheckboxes();
    if (!selection) return onFilterChange(null);
    onFilterChange({ artist: selection.id });
  }

  function resetCheckboxes() {
    setSoloCheckbox(
      initCheckboxState("solo", "Solo Exhibitions", onSoloCheckboxChange)
    );
    setGroupCheckbox(
      initCheckboxState("group", "Group Exhibitions", onGroupCheckboxChange)
    );
    setFairsCheckbox(
      initCheckboxState("art_fairs", "Art Fairs", onFairsCheckboxChange)
    );
  }

  useEffect(() => {
    function onSuccess(response) {
      if (response.records && response.records.length > 0) {
        setArtists((artists) => [...artists, ...response.records]);
        setIsLoading(false);
      }
    }

    const fetchData = () => {
      setIsLoading(true);
      artistsWithExhibitionsApiRequest(artistQuery, onSuccess);
    };

    fetchData();
  }, [artistQuery]);

  if (artists.length <= 0) return null;

  return (
    <div className="m-sibling-nav a-bg-blue50">
      <div className="m-sibling-nav__inner">
        <PageSectionNav visibleSections={visibleSections} />
        <ArtistComboBox
          artists={artists}
          checkboxes={[soloCheckbox, groupCheckbox, fairsCheckbox]}
          onChange={onArtistChange}
          label="Filter by artist"
          placeholder="Artists"
          wrapperClass="m-sibling-nav__form"
          theme="subnav"
        />
      </div>
    </div>
  );
}

NavBar.displayName = "ExhibitionsLanding.NavBar";

NavBar.propTypes = {
  onFilterChange: PropTypes.func.isRequired,
  visibleSections: PropTypes.object,
};

export default NavBar;
